import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

import { AvailabilityPickerComponent } from './availability-picker.component'

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    AvailabilityPickerComponent,
  ],
  declarations: [
    AvailabilityPickerComponent,
  ],
  providers: [],
})
export class AvailabilityPickerModule { }
